import { Injector, NgModule, inject, provideAppInitializer } from '@angular/core';
import { HeaderCitySelectModule } from './city-select/views/header/header-city-select.module';
import { CityUiEventHandler } from './city-ui.event-handler';

export function initFactory(injector: Injector): () => void {
  return () => {
    const eventHandler = injector.get(CityUiEventHandler);
    eventHandler.init();
  };
}

@NgModule({
  imports: [HeaderCitySelectModule],
  providers: [
    provideAppInitializer(() => {
      const initializerFn = initFactory(inject(Injector));

      return initializerFn();
    }),
  ],
})
export class CityUiModule {}
